import api from '../utils/api';

export async function getGoogleDriveAuthUrl() {
  const { data } = await api.get('/integrations/google-drive/auth-url');
  return data;
}

export async function getGoogleDriveStatus() {
  const { data } = await api.get('/integrations/google-drive/status');
  return data;
}

export async function disconnectGoogleDrive() {
  const { data } = await api.delete('/integrations/google-drive/status');
  return data;
}

export async function listGoogleDriveFolders({ parentId = 'root', pageToken } = {}) {
  const params = { parent_id: parentId };
  if (pageToken) {
    params.page_token = pageToken;
  }
  const { data } = await api.get('/integrations/google-drive/folders', { params });
  return data;
}
